import React from 'react';
import { di } from 'react-magnetic-di';
import { useEditorViewHasInfos } from '../../hooks/use-editor-view-has-infos';
import { useEditorViewHasWarnings } from '../../hooks/use-editor-view-has-warnings';
import { useEditorViewIsInvalid } from '../../hooks/use-editor-view-is-invalid';
import { JQLEditorHelp } from './jql-editor-help';
import { ErrorMessages, InfoMessages, WarningMessages } from './jql-messages';

/**
 * Message components are rendered by priority.
 * Message component decides on its own what exactly to render (GQL vs external messages).
 */

export var JQLEditorFooterContent = function JQLEditorFooterContent() {
  var editorViewIsInvalid = useEditorViewIsInvalid();
  var editorViewHasWarnings = useEditorViewHasWarnings();
  var editorViewHasInfos = useEditorViewHasInfos();
  if (editorViewIsInvalid) {
    return /*#__PURE__*/React.createElement(ErrorMessages, null);
  }
  if (editorViewHasWarnings) {
    return /*#__PURE__*/React.createElement(WarningMessages, null);
  }
  if (editorViewHasInfos) {
    return /*#__PURE__*/React.createElement(InfoMessages, null);
  }
  return /*#__PURE__*/React.createElement(JQLEditorHelp, null);
};